import { VeryTop } from './modules/VeryTop';
import { SecondStrip } from './modules/SecondStrip';
import { Location } from './modules/Location';
import { DressCode } from './modules/DressCode';
import { Timeline } from './modules/Timeline';
import { Meta } from './modules/Meta';
import { BBQ } from './modules/BBQ';
import { Agenda } from './modules/Agenda';
import { isPostWedding, isToday } from './after';
import { Fireworks } from './modules/Fireworks';

export function MainPage() {
    return <div>
        {isToday() && <Fireworks />}
        <VeryTop white />
        {!isPostWedding() && <BBQ white />}
        <SecondStrip />
        {
            !isPostWedding() && <>
                <Timeline  white />
                <DressCode />
                <Location white />
                <Agenda white />
                <Meta />
            </>
        }
    </div>
}
